export default __webpack_public_path__ + "static/media/FrontendCalendarIcon.85e79979.svg";